import { render, staticRenderFns } from "./AccountNotActivated.vue?vue&type=template&id=7f4279af&"
import script from "./AccountNotActivated.vue?vue&type=script&lang=ts&"
export * from "./AccountNotActivated.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports